import Vue from 'vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'

const LoadingPlugin = {
    install(Vue) {
        // 创建一个 Vue 实例来管理 loading 状态
        const LoadingConstructor = Vue.extend(LoadingOverlay)
        const loading = new LoadingConstructor()

        // 挂载但不显示在 DOM 中
        loading.$mount(document.createElement('div'))

        // 将 loading 实例添加到 Vue 的原型中，使其在所有组件中可用
        Vue.prototype.$loadingOverlay = loading

        // 同时保留一个全局变量，可用于非组件的 JS 文件
        Vue.loadingOverlay = loading
    }
}

// 自动安装
Vue.use(LoadingPlugin)

export default LoadingPlugin
